import { useAudit } from '../../api/hooks'
import { Card, PageHeader, Spinner } from '../../components/ui'
import { fmtDateTime } from '../../lib/format'

export function AuditPage() {
  const audit = useAudit()
  return (
    <>
      <PageHeader title="Aktivitetslogg" subtitle="Alla administrativa åtgärder loggas med användare och tidsstämpel (säkerhetskrav 6.1)." />
      <Card padded={false}>
        {audit.isLoading ? <Spinner /> : (
          <table className="w-full">
            <thead className="table-head"><tr><th>Tid</th><th>Användare</th><th>Åtgärd</th><th>Beskrivning</th></tr></thead>
            <tbody>
              {audit.data?.map((a) => (
                <tr key={a.id} className="table-row">
                  <td className="whitespace-nowrap tabular-nums text-ink-500">{fmtDateTime(a.created_at)}</td>
                  <td className="whitespace-nowrap font-medium text-ink-900">{a.user_name ?? 'System'}</td>
                  <td><code className="rounded bg-line-100 px-1.5 py-0.5 text-xs">{a.action}</code></td>
                  <td className="text-ink-700">{a.summary}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </>
  )
}
